function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxWxThresholds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.29 103.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.26,70.22a11.71,11.71,0,0,1-11.7-11.69,3.07,3.07,0,1,1,6.13,0A5.57,5.57,0,1,0,54.26,53H13.63a3.07,3.07,0,0,1,0-6.13H54.26a11.7,11.7,0,0,1,0,23.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.95,
    y: 93.73,
    width: 10.29,
    height: 7.81,
    rx: 1.91,
    transform: "translate(-74.54 120.74) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.96,
    y: 86.65,
    width: 24.46,
    height: 7.81,
    rx: 1.91,
    transform: "translate(-35.37 145.75) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.07,
    y: 90.84,
    width: 16.09,
    height: 7.81,
    rx: 1.91,
    transform: "translate(-55.63 133.86) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.64,
    y: 81.25,
    width: 35.26,
    height: 7.81,
    rx: 1.91,
    transform: "translate(-13.88 156.42) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,3.69A19.08,19.08,0,0,0,69.17,22.75a3.06,3.06,0,1,0,6.12,0,12.94,12.94,0,1,1,22.5,8.69,12.82,12.82,0,0,1,2.29,6.22,19,19,0,0,0-11.85-34ZM75,35.69H3.06a3.06,3.06,0,0,0,0,6.12H74.85L74.55,39v-.22A12.36,12.36,0,0,1,75,35.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.44,83.93a3.9,3.9,0,0,0,3.91,3.9h0a3.9,3.9,0,0,0,3.9-3.9l4.81-45.12a8.71,8.71,0,0,0-8.71-8.71h0a8.71,8.71,0,0,0-8.71,8.71l4.8,45.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.35,
    cy: 97.84,
    r: 5.46,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.32,29.92A9.72,9.72,0,0,1,18.61,11.7a12.07,12.07,0,0,1,22.88-5A9.43,9.43,0,0,1,55,14.05a7.88,7.88,0,0,1,1.82-.21,8,8,0,1,1,0,16.08Zm33.42-4.17a3.87,3.87,0,1,0-2.1-7.11,3.81,3.81,0,0,0-1.34,1.48A2.53,2.53,0,0,1,51,21.49a2.48,2.48,0,0,1-1.16-.28,2.53,2.53,0,0,1-1.09-3.41,8.8,8.8,0,0,1,2-2.6,5.28,5.28,0,0,0-10.55,0,2.54,2.54,0,0,1-5.07,0,10.34,10.34,0,0,1,2.44-6.67,7.85,7.85,0,0,0-14.51,1h.14a10.54,10.54,0,0,1,8.34,4.06,2.53,2.53,0,0,1-2,4.1,2.5,2.5,0,0,1-2-1,5.55,5.55,0,1,0-4.36,9Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxWxThresholds);
export default __webpack_public_path__ + "static/media/tx_WXThresholds.9caa80ed3668778744fb038e99c3c636.svg";
export { ForwardRef as ReactComponent };